import { useEffect, useState } from 'react';
import { getStatus, getNextVermut, diffParts } from '@/lib/schedule';

/** Returns { open, msg }, refreshing every 60s. */
export function useBarStatus() {
  const [status, setStatus] = useState(() => getStatus());
  useEffect(() => {
    const id = setInterval(() => setStatus(getStatus()), 60_000);
    return () => clearInterval(id);
  }, []);
  return status;
}

/** Returns { live, target, diff }, refreshing every second when not live. */
export function useNextVermut() {
  const [state, setState] = useState(() => {
    const t = getNextVermut();
    return t === 'live'
      ? { live: true, target: null, diff: null }
      : { live: false, target: t, diff: diffParts(t) };
  });

  useEffect(() => {
    const id = setInterval(() => {
      const t = getNextVermut();
      if (t === 'live') {
        setState({ live: true, target: null, diff: null });
      } else {
        setState({ live: false, target: t, diff: diffParts(t) });
      }
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return state;
}
